import {EventBus} from "@/hermeneus.eventbus/eventbus.js";


/**
 * Diese Komponente muss dort eingebunden werden, wo Modals der UebungenLibrary geöffnet werden sollen.
 * @type {{methods: {openUebungCreateModal(string): void}}}
 */
export const opensUebungCreateModalMixin = {

    methods: {
        /**
         * Öffnet das Modal mit der angegebenen Komponente:
         * componentPath und moduleName müssen in der config.json des Übungsmoduls angegeben sein und
         * können aus this.$UebungenRegistry geladen werden.
         * @param {Object} modalData -
         * {
         *        title: 'uebung.components.create.title',
         *        componentPath: 'uebung.components.create.path',
         *        moduleName: 'uebung.module.name',
         * }
         */
        openUebungCreateModal (modalData) {
            EventBus.$emit('openUebungCreateModal', modalData);
        },

    }
}
